// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".news[data-v-53254c63]{padding-bottom:300px}.news-title[data-v-53254c63]{margin-top:150px}@media screen and (max-width:1599px){.news[data-v-53254c63]{padding-bottom:135px}}@media screen and (max-width:767px){.news[data-v-53254c63]{padding-bottom:100px}.news-title[data-v-53254c63]{text-align:left}}", ""]);
// Exports
module.exports = exports;
